import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const containerStyle = css`
  display: flex;
  align-items: center;
  height: ${theme.spacing(4)};
  background-color: ${theme.colors.neutral10};
  border-radius: ${theme.spacing(0.75)};
  padding: ${theme.spacing(0.25)};
  width: fit-content;
`;

export const optionContainerBaseStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(0.5)};
  padding: ${theme.spacing(0.5, 1)};
  border-radius: ${theme.spacing(0.5)};
  background: transparent;
  box-shadow: none;
  height: ${theme.spacing(3.5)};

  svg {
    color: ${theme.font.colors.subdued};
    height: ${theme.spacing(2)};
    min-height: ${theme.spacing(2)};
    width: ${theme.spacing(2)};
    min-width: ${theme.spacing(2)};
  }

  .content-switcher-label {
    font-weight: ${theme.font.weight.regular};
    color: ${theme.font.colors.subdued};
  }

  &:hover {
    background-color: ${theme.colors.neutral20};
  }

  &:active {
    background: transparent !important;
    color: ${theme.font.colors.default} !important;

    svg {
      color: ${theme.font.colors.subdued} !important;
    }
  }

  &:focus-visible {
    box-shadow: ${theme.shadows.light};
  }
`;

export const optionContainerCheckedStyle = css`
  background: ${theme.colors.white};
  box-shadow: ${theme.shadows.light};

  .content-switcher-label {
    font-weight: ${theme.font.weight.bold};
    color: ${theme.font.colors.default};
  }

  &:hover {
    background-color: ${theme.colors.white};
  }

  &:active {
    background: ${theme.colors.white} !important;
  }
`;
